
import Heade from '../components/header.vue'
import fsySelect from '../components/fsySelect.vue'
import fsyRadio from '../components/fsyRadio.vue'
const myPlugin = {
  install:function (Vue) {
    Vue.component('Heade',Heade);
    Vue.component('fsySelect',fsySelect);
    Vue.component('fsyRadio',fsyRadio);
  }
}
export default myPlugin